import {useState} from "react";

function App() {

  const [question,setQuestion]=useState("");
  const [answer,setAnswer]=useState("");

  const askAI=async()=>{

    const res=await fetch("/api/ask",{
      method:"POST",
      headers:{ "Content-Type":"application/json" },
      body:JSON.stringify({question})
    });

    const data=await res.json();

    setAnswer(data.answer);

  };

  return (
    <div style={{padding:"40px"}}>

      <h2>DiaTrac Brain AI</h2>

      <input
        value={question}
        onChange={e=>setQuestion(e.target.value)}
        placeholder="Ask something..."
      />

      <button onClick={askAI}>
        Ask
      </button>

      <p>{answer}</p>

    </div>
  );
}

export default App;